import { render, staticRenderFns } from "./ReservationThankyou.vue?vue&type=template&id=1abcfca1&"
import script from "./ReservationThankyou.vue?vue&type=script&lang=js&"
export * from "./ReservationThankyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports